import { useCallback, useState } from 'react';

import { ToggleOptionGroup, ToggleOptionGroupItem } from 'twyne-new.ui'

import { useCraftProp } from '@/components/builder/utils';

export default function RadioGroupProperty({ name, options }) {
  const { value: defaultValue, setValue } = useCraftProp(name)
  const [selected, setSelected] = useState(options.find(item => getValue(item) === defaultValue))

  const handleChange = useCallback(item => {
    setSelected(item)
    setValue(getValue(item))
  }, [setValue])

  return <ToggleOptionGroup type='single' onValueChange={handleChange} defaultValue={selected}>
    {options.map((item, idx) => <ToggleOptionGroupItem key={idx} value={item}>
      {item.label}
    </ToggleOptionGroupItem>)}
  </ToggleOptionGroup>
}

function getValue({ type, value: _value, value: { value = _value } }) {
  switch (type) {
    case 'number':
      return parseFloat(value)
    case 'boolean':
      return JSON.parse(value)
    default:
      return value
  }
}
